import {Box, Icon, Typography} from '@mui/material';

import {ViewModelProvider} from './ViewModelContext';

import './styles';

const IdvDocsSubmittedContent = () => {
  return (
    <Box className="idv-docs-submitted-container">
      <img
        src="/assets/images/etc/pending.svg"
        alt="time"
        style={{
          width: '120px',
          height: '120px',
        }}
      />
      <Box className="text-container">
        <Typography className="text-title">
          Thank you for your answer!
        </Typography>
      </Box>
      <Box className="explanations-container">
        <Box className="testimonial-container">
          <Box className="testimonial-item">
            <Icon style={{fontSize: 24, color: '#000000'}}>mail</Icon>
            <Typography className="testimonial-text">
              Once we verify the information, you will receive an email with an
              update on your account status.
            </Typography>
          </Box>
          <Box className="testimonial-item">
            <Icon style={{fontSize: 24, color: '#000000'}}>schedule</Icon>
            <Typography className="testimonial-text">
              This can take 1-4 business days. You may now close this window.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const IdvDocsSubmittedPage = () => (
  <ViewModelProvider>
    <IdvDocsSubmittedContent />
  </ViewModelProvider>
);

export default IdvDocsSubmittedPage;
